import {permiteRol} from '../utils/permisosRol';
import React from 'react';
import { useAuth } from '../context/AuthContext';
import { normalizarRol, perfilOperativo } from '../utils/authProfile';

export default function Protected({ roles, children,capacidad }) {
  const { user, profile, loading, profileVerified,permissionsVerified } = useAuth();
  if (loading) return <div style={{ padding: 24 }}>Cargando…</div>;

  const rol = normalizarRol(profile?.rol);
  const authorized = !!user && profileVerified && perfilOperativo(profile) &&
    (rol==='owner'||permissionsVerified!==false) && (!capacidad||permiteRol(profile,capacidad)) &&
    (!roles?.length || roles.map(normalizarRol).includes(rol)||(capacidad&&permiteRol(profile,capacidad)));

  if (!authorized) {
    return (
      <div style={{ padding: 48, textAlign: 'center', fontWeight: 800 }}>
        {profile?.activo === false ? 'USUARIO DESACTIVADO' : 'ACCESO NO AUTORIZADO'}
      </div>
    );
  }
  return <>{children}</>;
}
